<template>
  <div class="d-flex" style="position: relative">
    <v-autocomplete
      color="red"
      outlined
      :clearable="!readonly"
      :items="data"
      :item-text="textField"
      :item-value="valueField"
      :item-disabled="checkDisabled"
      :value="value"
      :label="$t(titleValue)"
      :error-messages="error"
      :disabled="disabled"
      :hide-details="config.hideDetails || false"
      :dense="config.dense || false"
      :readonly="readonly"
      :prefix="preText"
      :no-data-text="'Нет вариантов для выбора'"
      :small-chips="model.chips || false"
      :multiple="model.chips || false"
      :deletable-chips="model.chips || false"
      :hide-selected="model.chips || false"
      :loading="loading"
      @keydown="onKeyDown"
      @input="
        $emit('input', $event);
        sendData($event);
        cascade($event);
      "
      @focus="onMenuToggle"
      class="list-hide-disabled"
    />
    <btn-rating v-if="(model.rating && config.rating) || false" />
  </div>
</template>

<script>
import { libChecks, modelOptions } from "@/components/mixings";

export default {
  mixins: [libChecks, modelOptions],
  props: {
    value: [String, Number, Object, Array],
    values: Object,
    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {} },
  },
  data() {
    return {
      data: [],
      title: null,
      preText: null,
      showAllItem: false,
      _valueField: null,
      _textField: null,
      api: "",
      loading: true,
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    value(v) {
      if (v !== undefined) this.fetchData();
    },
    "model.filters"(v) {
      //console.log("model.filters");
      this.fetchData();
    },
    "model.api"(v) {
      //console.log("model.filters");
      this.fetchData();
    },
  },
  computed: {
    titleValue() {
      return this.title || this.model.title;
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly || this.getReadonly(this.model, this.values)) return true;
      return false;
    },
    textField() {
      return this._textField || this.model?.itemField?.text || "text";
    },
    valueField() {
      return this._valueField || this.model?.itemField?.value || "value";
    },
  },
  methods: {
    onMenuToggle() {
      console.log("onMenuToggle");
      if (this.model?.menuToggle) {
        this.fetchData();
      }
    },
    onKeyDown(e) {
      if (e.key === "*") {
        this.showAllItem = !this.showAllItem;
        console.log("showAllItem");
        this.$emit("showAllItem", this.showAllItem);
      }
    },
    checkDisabled(e) {
      if (this.showAllItem) return false;
      if (e?.isActive === false || e.hidden) return true;
      if (!this.model.isActive && this.model?.isActive != undefined) return false;
      return false;
    },
    getApi(model) {
      let api = "";
      if (model?.api?.func) {
        let f = eval(model.api.func);
        return f(this.values);
      }

      if (model?.apiVar) {
        const key = model.apiVar.key;
        if (this.values) {
          const v = model?.json ? this.values?.data?.[key] : this.values[key];
          const name = model.apiVar.apiName.find((el) => {
            return el.value == v;
          });
          let idField = model.apiVar?.idField || null;
          api = name?.name || "";
          this.title = name?.title || null;
          this._valueField = name?.itemField?.value;
          this._textField = name?.itemField?.text;
          this.preText = name?.preText || null;
        }
        return api;
      }
      return model.api;
    },

    async fetchData() {
      let api = await this.getApi(this.model);
      this.api = api;
      if (!api) return;
      let type = "get";
      let data = {};
      if (typeof api === "object") {
        type = api.type || type;
        if (api.data) {
          data.name = api.data?.name;
          data.params = {};
          for (const key in api.data.params) {
            if (typeof api.data.params[key] === "string" && api.data.params[key].includes("function(d)")) {
              let func = eval(api.data.params[key]);
              //console.log("ddddddd", func, this.values);
              data.params[key] = func(this.values) || 0;
            } else data.params[key] = api.data.params[key];
          }
        }

        //data = api.data || null;
        api = api.api;
      }

      if (!api) return;

      let params = {};
      if (this.model.sort) {
        params.sort = this.model.sort;
      }
      if (this.model.filters) {
        if (this.model.filters.formula) {
          let res = eval(this.model.filters.formula || "{}");
          if (typeof res === "function") res = res(this.values);
          params.filters = res;
        } else params.filters = this.model.filters;
      }
      if (this.model?.where) {
        params.where = this.model.where;
      }
      data.filters = Object.assign({}, params.filters);
      this.loading = true;
      if (type !== "get") {
        //console.log(data);
      }
      let response = type == "get" ? await this.$axios.get(api, { params }) : await this.$axios.post(api, data);
      this.loading = false;
      let d = this.filterItems(response.data.data).multiSort(["disabled", "text"]);
      this.data = [...d];
      if (this.data.length == 1 && this.model?.autoValue === true) {
        if (!this.value && this.values && !this.values?.id) {
          this.$emit("input", this.data[0][this.valueField]);
        }
      }
    },
    sendData(v) {
      let selected = this.data.find((d) => d?.[this.valueField] == v);
      if (selected) {
        this.$emit("fieldData", selected);
      }
      this.$emit("selected", selected);
    },
    cascade(e) {
      if (this.model?.cascade) {
        for (const key in this.model.cascade) {
          const el = this.model.cascade[key];
          if (el.type == "field") {
            let value = this.data.find((f) => f["value"] == e)?.[el.value];
            if (value !== undefined) {
              this.$emit("cascade", { field: key, value });
            } else {
            }
          }
          if (el.type == "formula") {
            let func;
            let f = this.data.find((f) => f["value"] == e)?.[el.value];
            console.log(el.type, f);
            if (typeof f == "string") func = eval(f);
            let value = func(this.values);
            if (value !== undefined) {
              this.$emit("cascade", { field: key, value });
            }
          }
          if (el.type == "value") {
            console.log(el);
            this.$emit("cascade", { field: key, value: el.value });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-list-item.v-list-item--disabled11 {
  display: none !important;
}
</style>
